
import React, { useState, useEffect } from 'react'
import ReactPlayer from 'react-player';
import { LoadAllProgram } from '../actions/Activites/Programmes';
import { LoadAllAccueil, LoadAllAccueilComposant } from '../actions/ActivitesPages/ManagerPageAction';
import LoadingProfile from '../components/LoadingProfile';
import AllRoutes from '../nametitle/AllRoutes';
import SocialMedia from '../components/SocialMedia';
import LocationChurch from '../components/LocationChurch';
import { getDataFromFile } from '../actions/SearchAction';
import { Localvalue } from '../nametitle/localValue';
// import "react-multi-carousel/lib/styles.css";


const HomePage = () => {

    const [id, setid] = useState();

    const [coverPictureHome1, setcoverPictureHome1] = useState();
    const [videoHome, setVideoHome] = useState();
    const [titleHome, settitleHome] = useState();
    const [descriptionHome1, setdescriptionHome1] = useState();

    // Accitite 2
    const [coverPictureHome2, setcoverPictureHome2] = useState();
    const [versetHome2, setversetHome2] = useState();
    const [titleHome2, settitleHome2] = useState();
    const [description1, setdescription1] = useState();
    const [description2, setdescription2] = useState();


    const [coverPictureHome3, setcoverPictureHome3] = useState();
    const [titleHome3, settitleHome3] = useState();
    const [descriptionHome3, setdescriptionHome3] = useState();


    const bgImg = "https://images.pexels.com/photos/158465/waterlily-pink-water-lily-water-plant-158465.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2";
    const Video = "https://www.youtube.com/watch?v=7ON44YyCDLU&t=21s";
    const bgImg2 = "https://scontent.fabj2-1.fna.fbcdn.net/v/t1.6435-9/142469020_1095048217634436_853363959839842407_n.jpg?_nc_cat=110&ccb=1-7&_nc_sid=730e14&_nc_eui2=AeE_E5HJ29XnZk3vpQZ9f9P5vQFumNIY5IG9AW6Y0hjkgcyWkWabYeVQPwXXHOtw4e_529D5EQBGIm0JBXBuuD4M&_nc_ohc=pKqHqE4nV6QAX9Add6P&_nc_ht=scontent.fabj2-1.fna&oh=00_AfCa9f0OqJ7LiPfreFNXsWSLYA0DPe1ejTrzL6IRDbgG5w&oe=63B9644E"

    const [ProgramList, setProgramList] = useState([1]);
    const [LoadingAll, setLoadingAll] = useState([]);




    useEffect(() => {
        const object = getDataFromFile(Localvalue.activitePageData);
        setVideoHome(object && object.accueil && object.accueil.activite1 && object.accueil.activite1.video ? object.accueil.activite1.video : "");
      setcoverPictureHome1(object && object.accueil && object.accueil.activite1 && object.accueil.activite1.coverPicture ? object.accueil.activite1.coverPicture : "");
      settitleHome(object && object.accueil && object.accueil.activite1 && object.accueil.activite1.title ? object.accueil.activite1.title : "");
      setdescriptionHome1(object && object.accueil && object.accueil.activite1 && object.accueil.activite1.description ? object.accueil.activite1.description : "");
      // ***************************************************     Activté 2
      setversetHome2(object && object.accueil && object.accueil.activite2 && object.accueil.activite2.verset ? object.accueil.activite2.verset : "");
      setcoverPictureHome2(object && object.accueil && object.accueil.activite2 && object.accueil.activite2.coverPicture ? object.accueil.activite2.coverPicture : "");
      settitleHome2(object && object.accueil && object.accueil.activite2 && object.accueil.activite2.title ? object.accueil.activite2.title : "");
      setdescription2(object && object.accueil && object.accueil.activite2 && object.accueil.activite2.description1 ? object.accueil.activite2.description1 : "");
      setdescriptionHome3(object && object.accueil && object.accueil.activite2 && object.accueil.activite2.description2 ? object.accueil.activite2.description2 : "");
      // *****************************************************   Activté 3
      setcoverPictureHome3(object && object.accueil && object.accueil.activite3 && object.accueil.activite3.coverPicture ? object.accueil.activite3.coverPicture : "");
      settitleHome3(object && object.accueil && object.accueil.activite3 && object.accueil.activite3.title ? object.accueil.activite3.title : "");
      setdescriptionHome3(object && object.accueil && object.accueil.activite3 && object.accueil.activite3.description ? object.accueil.activite3.description : "");

        LoadAllProgram(setProgramList);
        LoadAllAccueil(
            setid,
            setVideoHome, setcoverPictureHome1, setdescriptionHome1, settitleHome,
            setcoverPictureHome2, setversetHome2, settitleHome2, setdescription1, setdescription2,
            setcoverPictureHome3, setdescriptionHome3, settitleHome3
        );
        LoadAllAccueilComposant(setLoadingAll);
    }, []);





    return (
        <div>



            {
                coverPictureHome1 || coverPictureHome2  ?
                    <div>
                        <div className="container-fluid bg-primary py-5 mb-5 hero-header" style={{ backgroundImage: `url('${coverPictureHome1}')` }}>
                            <div className="container py-5" >
                                <div className="row justify-content-start" >
                                    <div className="col-lg-8 text-center text-lg-start">
                                        <h1 className="display-1 text-uppercase  mb-lg-4 text-gray-200 "><span classname="translatable">Ministère de la pleintude en Christ</span></h1>
                                        <h1 className="text-uppercase text-white mb-lg-4 "><span className="translatable">Fait de Jésus ta priorité</span></h1>
                                        <p className="fs-4 text-white mb-lg-4"><span className="translatable">Nous sommes une église evangélique dirigée par le couple prophétique SETH et EMMANUELLA BOATENG</span></p>
                                        <div className="d-flex align-items-center justify-content-center justify-content-lg-start pt-5">
                                            {/* <a href="" className="btn btn-outline-light border-2 py-md-3 px-md-5 me-5">Voire plus</a> */}
                                            <button type="button" className="btn-play" data-bs-toggle="modal"
                                                data-src={Video} data-bs-target="#videoModal">
                                                <span></span>
                                            </button>
                                            <h5 className="font-weight-normal text-white m-0 ms-4 d-none d-sm-block translatable"><span className="translatable">Jouer la vidéo</span></h5>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>



                        <div className="modal fade" id="videoModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                            <div className="modal-dialog">
                                <div className="modal-content rounded-0">
                                    <div className="modal-header">
                                        {
                                            /**
                                             * <h5 className="modal-title" id="exampleModalLabel">Titre de vidéo en question </h5>
                                             */
                                        }
                                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                                    </div>
                                    <div className="modal-body">
                                        <div className="ratio ratio-16x9">
                                            {/* Lien de video  */}
                                            <ReactPlayer url={`${videoHome}`} controls height={`100%`} width={`100%`} className="h-[100%] w-[100%]" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>



                        <div className="container-fluid py-5 px-5 ">
                            <div className="container border shadow-md p-5 rounded-2xl">
                                <div className="row gx-5">
                                    <div className="col-lg-5 mb-5 mb-lg-0" style={{ minHeight: "500px" }}>
                                        <div className="position-relative h-100">
                                            <img className="position-absolute w-100 h-100 rounded-3xl" src={`${coverPictureHome2}`} style={{ objectFit: "cover" }} />
                                        </div>
                                    </div>
                                    <div className="col-lg-7">
                                        <div className="border-start border-3 rounded-lg border-primary ps-5 mb-5">
                                            <h6 className="text-primary text-uppercase"></h6>
                                            <h1 className="display-6 text-uppercase mb-0 translatable">{titleHome2}</h1>
                                        </div>
                                        <h4 className="text-body mb-4 translatable">
                                            {versetHome2}
                                        </h4>
                                        <div className="bg-light p-4 rounded-2xl">
                                            <ul className="nav nav-pills justify-content-between mb-3" id="pills-tab" role="tablist">
                                                <li className="nav-item w-50" role="presentation">
                                                    <button className="nav-link text-uppercase w-100 active rounded-2xl translatable" id="pills-1-tab" data-bs-toggle="pill"
                                                        data-bs-target="#pills-1" type="button" role="tab" aria-controls="pills-1"
                                                        aria-selected="true"> Mission</button>
                                                </li>
                                                <li className="nav-item w-50" role="presentation">
                                                    <button className="nav-link text-uppercase w-100 rounded-2xl translatable" id="pills-2-tab" data-bs-toggle="pill"
                                                        data-bs-target="#pills-2" type="button" role="tab" aria-controls="pills-2"
                                                        aria-selected="false">La vision</button>
                                                </li>
                                            </ul>
                                            <div className="tab-content" id="pills-tabContent">
                                                <div className="tab-pane fade show active" id="pills-1" role="tabpanel" aria-labelledby="pills-1-tab">
                                                    <p className="mb-0 translatable" >{`${description1}`.toLocaleUpperCase()}</p>
                                                </div>
                                                <div className="tab-pane fade" id="pills-2" role="tabpanel" aria-labelledby="pills-2-tab">
                                                    <p className="mb-0 translatable">{`${description2}`.toLocaleUpperCase()}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {
                            /*
        
                            <Carousel className="row">
                            <div className="col-md-4">
                                <div className="card mb-4 bg-dark text-white">
                                    <img className="card-img" src={coverPictureHome1} alt="Card image" />
                                    <div className="card-img-overlay">
                                        <h5 className="card-title">Card title</h5>
                                        <p className="card-text">This is a wider card with supporting text below as a natural lead-in to additional content. This content is a little bit longer.</p>
                                        <p className="card-text">Last updated 3 mins ago</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="card mb-4 bg-dark text-white">
                                    <img className="card-img" src={coverPictureHome1} alt="Card image" />
                                    <div className="card-img-overlay">
                                        <h5 className="card-title">Card title</h5>
                                        <p className="card-text">This is a wider card with supporting text below as a natural lead-in to additional content. This content is a little bit longer.</p>
                                        <p className="card-text">Last updated 3 mins ago</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="card mb-4 bg-dark text-white">
                                    <img className="card-img" src={coverPictureHome1} alt="Card image" />
                                    <div className="card-img-overlay">
                                        <h5 className="card-title">Card title</h5>
                                        <p className="card-text">This is a wider card with supporting text below as a natural lead-in to additional content. This content is a little bit longer.</p>
                                        <p className="card-text">Last updated 3 mins ago</p>
                                    </div>
                                </div>
                            </div>
                        </Carousel>
                            */
                        }




                        <div className="container-fluid py-5">
                            <div className="container ">
                                <div className="border-start w-full border-3 rounded-lg border-primary ps-5 mb-5" >
                                    <h6 className="text-primary  text-uppercase text-xl"></h6>
                                    <h1 className="display-5 text-uppercase mb-0 text-center translatable">Nos différents programmes</h1>
                                </div>

                                <div className="py-16 bg-white rounded-lg">
                                    <div className="container m-auto px-6 text-gray-500 md:px-12 xl:px-0">
                                        <div className="mx-auto flex-wrap justify-center  grid gap-6 md:w-3/4 lg:w-full lg:grid-cols-3">
                                            {
                                                ProgramList.map((item) => {
                                                    return (
                                                        <div className="bg-white rounded-2xl border flex flex-col shadow px-8 py-12 sm:px-12 lg:px-8">
                                                            <div className="mb-12 space-y-4 ">
                                                                <h3 className="text-2xl font-semibold text-lime-700 translatable">{item.title}</h3>
                                                                <p className="mb-6 translatable">{
                                                                    item.description
                                                                }</p>
                                                                <a href="#" className="block font-medium text-lime-600 translatable">Nous contacter</a>
                                                            </div>
                                                            <img src={item.coverPicture} className="w-[100px] h-[100px] ml-auto -mb-12" alt="illustration" loading="lazy"  />
                                                        </div>
                                                    )
                                                })
                                            }

                                        </div>
                                    </div>
                                </div>


                                <SocialMedia/>
                                {
                                    /*<div className="row g-5">
                                    {
                                        ProgramList.map((item) => {
                                            return (
                                                <div className="col-md-6">
                                                    <div className="service-item bg-light d-flex p-4">
                                                        <img src={`${item.coverPicture}`} className="h-[100px] w-[100px]" />
                                                        <div>
                                                            <h5 className="text-uppercase mb-3">{item.title}</h5>
                                                            <p>{item.description}</p>
                                                            <a className="text-primary text-uppercase" href="">Voire plus<i className="bi bi-chevron-right"></i></a>
                                                        </div>
                                                    </div>
                                                </div>
                                            )
                                        })
                                    }

                                </div> */
                                }
                            </div>
                        </div>




                        <div className="bg-cover mx-5 rounded-2xl rounded-t-2xl bg-center flex  justify-center h-[540px] text-gray-500  object-fill" style={{ backgroundImage: `url('${coverPictureHome3}')` }}>
                            <div className="w-full flex justify-center rounded-t-2xl items-center px-4 bg-gradient-to-t from-transparent to-black/60">
                                <div className=" space-y-3">
                                    <p className="font-bold text-sm uppercase "></p>
                                    <p className="text-xl font-bold text-white text-center translatable">{titleHome3}</p>
                                    {/*<p className="text-2xl mb-10 leading-none text-gray-100">{descriptionHome3}</p> */}
                                    <div className="mt-5 flex justify-center">
                                        <a href={`/${AllRoutes.contact}`} className="bg-white mt-3 py-3 px-8 text-lime-600 font-bold uppercase text-lg rounded hover:bg-lime-200 hover:text-lime-900 translatable">Nous contacter</a>

                                    </div>
                                </div>

                            </div>
                        </div>




                        {
                            /*<div className="container-fluid  py-5" style={{ margin: "45px 0", height: "400px", backgroundImage: `url('${bgImg2}')` }}>
                            <div className="container py-5">
                                <div className="row justify-content-end">
                                    <div className="col-lg-7">
                                        <div className=" bg-white p-5">
                                            <div className="testimonial-item text-center">
                                                <div className="relative position-relative mb-4">
                                                    <img className="img-fluid w-full h-[300px] mx-auto" src={`${bgImg2}`} alt="" />
                                                    <div className="  flex align-items-center justify-content-center bg-white" style={{ width: "45px", height: "45px" }}>
                                                        <i className="bi bi-chat-square-quote text-primary"></i>
                                                    </div>
                                                    <div>
                                                        <button className="border-gray-200 p-5 rounded-lg text-gray-200">Suivre</button>
                                                    </div>

                                                </div>
                                                <p>Dolores sed duo clita tempor justo dolor et stet lorem kasd labore dolore lorem ipsum. At lorem lorem magna ut et, nonumy et labore et tempor diam tempor erat. Erat dolor rebum sit ipsum.</p>
                                                <hr className="w-25 mx-auto" />
                                                <h5 className="text-uppercase">Client Name</h5>
                                                <span>Profession</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
 */
                        }


                        <LocationChurch/>


                    </div>

                    :
                    <LoadingProfile />

            }

        </div >
    )
}

export default HomePage;